import { SplitButtonOption } from '@freelancer/ui/split-button';
import { MilestoneConfirmModalType } from '../milestone-confirm-modal/milestone-confirm-modal.types';

// todo: is this useful?
export interface MilestoneAction extends SplitButtonOption {
  confirm?: MilestoneConfirmModalType;
  callback: Function;
}

export enum MilestoneActions {
  CANCEL = 'cancel',
  CANCEL_REQUEST = 'request_cancel',
  CREATE_SIMILAR = 'create_similar',
  DISPUTE = 'dispute',
  DISPUTE_VIEW = 'dispute_view',
  MAKE_DECISION = 'make_decision',
  RELEASE = 'release',
  RELEASE_REQUEST = 'request_release',
  UPDATE = 'update',
}

export enum MilestoneActionReasons {
  ACCIDENT = 'accidentally_created',
  NO_LONGER_NEEDED = 'no_longer_needed',
  DEADLINE = 'freelancer_did_not_meet_deadline',
  INCOMPLETE = 'freelancer_did_not_complete_task',
  OTHER = 'other',
}

export enum MilestoneListStatsItemType {
  IN_PROGRESS,
  RELEASED,
  REQUESTED,
}
